var city = {
  citycode: [],
  adcode: "420000",
  name: "湖北省",
  center: {
    lng: 114.341552,
    lat: 30.546222
  },
  districtList: [
    {
      citycode: "0710",
      adcode: "420600",
      name: "襄阳市",
      center: {
        lng: 112.121743,
        lat: 32.010161
      },
      districtList: [
        {
          citycode: "0710",
          adcode: "420625",
          name: "谷城县",
          center: {
            lng: 111.653077,
            lat: 32.26339
          }
        },
        {
          citycode: "0710",
          adcode: "420684",
          name: "宜城市",
          center: {
            lng: 112.256486,
            lat: 31.720278
          }
        },
        {
          citycode: "0710",
          adcode: "420683",
          name: "枣阳市",
          center: {
            lng: 112.772723,
            lat: 32.128968
          }
        },
        {
          citycode: "0710",
          adcode: "420626",
          name: "保康县",
          center: {
            lng: 111.261308,
            lat: 31.87831
          }
        },
        {
          citycode: "0710",
          adcode: "420624",
          name: "南漳县",
          center: {
            lng: 111.838997,
            lat: 31.774649
          }
        },
        {
          citycode: "0710",
          adcode: "420607",
          name: "襄州区",
          center: {
            lng: 112.211365,
            lat: 32.088651
          }
        },
        {
          citycode: "0710",
          adcode: "420602",
          name: "襄城区",
          center: {
            lng: 112.134025,
            lat: 32.009932
          }
        },
        {
          citycode: "0710",
          adcode: "420606",
          name: "樊城区",
          center: {
            lng: 112.135241,
            lat: 32.045065
          }
        },
        {
          citycode: "0710",
          adcode: "420682",
          name: "老河口市",
          center: {
            lng: 111.683861,
            lat: 32.359068
          }
        }
      ]
    },
    {
      citycode: "0719",
      adcode: "420300",
      name: "十堰市",
      center: {
        lng: 110.798921,
        lat: 32.629057
      },
      districtList: [
        {
          citycode: "0719",
          adcode: "420304",
          name: "郧阳区",
          center: {
            lng: 110.812101,
            lat: 32.834847
          }
        },
        {
          citycode: "0719",
          adcode: "420302",
          name: "茅箭区",
          center: {
            lng: 110.813478,
            lat: 32.591847
          }
        },
        {
          citycode: "0719",
          adcode: "420303",
          name: "张湾区",
          center: {
            lng: 110.769132,
            lat: 32.652297
          }
        },
        {
          citycode: "0719",
          adcode: "420323",
          name: "竹山县",
          center: {
            lng: 110.229696,
            lat: 32.225039
          }
        },
        {
          citycode: "0719",
          adcode: "420324",
          name: "竹溪县",
          center: {
            lng: 109.715322,
            lat: 32.318257
          }
        },
        {
          citycode: "0719",
          adcode: "420325",
          name: "房县",
          center: {
            lng: 110.726754,
            lat: 32.04017
          }
        },
        {
          citycode: "0719",
          adcode: "420322",
          name: "郧西县",
          center: {
            lng: 110.426005,
            lat: 32.993095
          }
        },
        {
          citycode: "0719",
          adcode: "420381",
          name: "丹江口市",
          center: {
            lng: 111.513318,
            lat: 32.540287
          }
        }
      ]
    },
    {
      citycode: "0717",
      adcode: "420500",
      name: "宜昌市",
      center: {
        lng: 111.286962,
        lat: 30.69217
      },
      districtList: [
        {
          citycode: "0717",
          adcode: "420526",
          name: "兴山县",
          center: {
            lng: 110.746831,
            lat: 31.348065
          }
        },
        {
          citycode: "0717",
          adcode: "420527",
          name: "秭归县",
          center: {
            lng: 110.97793,
            lat: 30.825882
          }
        },
        {
          citycode: "0717",
          adcode: "420504",
          name: "点军区",
          center: {
            lng: 111.268338,
            lat: 30.69343
          }
        },
        {
          citycode: "0717",
          adcode: "420582",
          name: "当阳市",
          center: {
            lng: 111.78836,
            lat: 30.820893
          }
        },
        {
          citycode: "0717",
          adcode: "420581",
          name: "宜都市",
          center: {
            lng: 111.450128,
            lat: 30.378444
          }
        },
        {
          citycode: "0717",
          adcode: "420525",
          name: "远安县",
          center: {
            lng: 111.640329,
            lat: 31.060904
          }
        },
        {
          citycode: "0717",
          adcode: "420503",
          name: "伍家岗区",
          center: {
            lng: 111.360882,
            lat: 30.644048
          }
        },
        {
          citycode: "0717",
          adcode: "420505",
          name: "猇亭区",
          center: {
            lng: 111.434378,
            lat: 30.531133
          }
        },
        {
          citycode: "0717",
          adcode: "420583",
          name: "枝江市",
          center: {
            lng: 111.760616,
            lat: 30.425758
          }
        },
        {
          citycode: "0717",
          adcode: "420529",
          name: "五峰土家族自治县",
          center: {
            lng: 111.07374,
            lat: 30.156741
          }
        },
        {
          citycode: "0717",
          adcode: "420506",
          name: "夷陵区",
          center: {
            lng: 111.326371,
            lat: 30.769875
          }
        },
        {
          citycode: "0717",
          adcode: "420502",
          name: "西陵区",
          center: {
            lng: 111.285696,
            lat: 30.710765
          }
        },
        {
          citycode: "0717",
          adcode: "420528",
          name: "长阳土家族自治县",
          center: {
            lng: 111.20697,
            lat: 30.473038
          }
        }
      ]
    },
    {
      citycode: "027",
      adcode: "420100",
      name: "武汉市",
      center: {
        lng: 114.304569,
        lat: 30.593354
      },
      districtList: [
        {
          citycode: "027",
          adcode: "420117",
          name: "新洲区",
          center: {
            lng: 114.801284,
            lat: 30.841304
          }
        },
        {
          citycode: "027",
          adcode: "420113",
          name: "汉南区",
          center: {
            lng: 114.084582,
            lat: 30.308776
          }
        },
        {
          citycode: "027",
          adcode: "420114",
          name: "蔡甸区",
          center: {
            lng: 114.087279,
            lat: 30.536395
          }
        },
        {
          citycode: "027",
          adcode: "420115",
          name: "江夏区",
          center: {
            lng: 114.320884,
            lat: 30.37558
          }
        },
        {
          citycode: "027",
          adcode: "420106",
          name: "武昌区",
          center: {
            lng: 114.316464,
            lat: 30.55418
          }
        },
        {
          citycode: "027",
          adcode: "420102",
          name: "江岸区",
          center: {
            lng: 114.309317,
            lat: 30.600008
          }
        },
        {
          citycode: "027",
          adcode: "420112",
          name: "东西湖区",
          center: {
            lng: 114.136295,
            lat: 30.620079
          }
        },
        {
          citycode: "027",
          adcode: "420107",
          name: "青山区",
          center: {
            lng: 114.385424,
            lat: 30.639842
          }
        },
        {
          citycode: "027",
          adcode: "420105",
          name: "汉阳区",
          center: {
            lng: 114.21859,
            lat: 30.554287
          }
        },
        {
          citycode: "027",
          adcode: "420116",
          name: "黄陂区",
          center: {
            lng: 114.375698,
            lat: 30.882305
          }
        },
        {
          citycode: "027",
          adcode: "420111",
          name: "洪山区",
          center: {
            lng: 114.342664,
            lat: 30.500642
          }
        },
        {
          citycode: "027",
          adcode: "420103",
          name: "江汉区",
          center: {
            lng: 114.270763,
            lat: 30.601129
          }
        },
        {
          citycode: "027",
          adcode: "420104",
          name: "硚口区",
          center: {
            lng: 114.214746,
            lat: 30.582559
          }
        }
      ]
    },
    {
      citycode: "0713",
      adcode: "421100",
      name: "黄冈市",
      center: {
        lng: 114.872425,
        lat: 30.453722
      },
      districtList: [
        {
          citycode: "0713",
          adcode: "421181",
          name: "麻城市",
          center: {
            lng: 115.008011,
            lat: 31.172917
          }
        },
        {
          citycode: "0713",
          adcode: "421102",
          name: "黄州区",
          center: {
            lng: 114.880104,
            lat: 30.434354
          }
        },
        {
          citycode: "0713",
          adcode: "421124",
          name: "英山县",
          center: {
            lng: 115.680953,
            lat: 30.734989
          }
        },
        {
          citycode: "0713",
          adcode: "421121",
          name: "团风县",
          center: {
            lng: 114.872364,
            lat: 30.643225
          }
        },
        {
          citycode: "0713",
          adcode: "421123",
          name: "罗田县",
          center: {
            lng: 115.399149,
            lat: 30.783047
          }
        },
        {
          citycode: "0713",
          adcode: "421127",
          name: "黄梅县",
          center: {
            lng: 115.944219,
            lat: 30.070453
          }
        },
        {
          citycode: "0713",
          adcode: "421122",
          name: "红安县",
          center: {
            lng: 114.618134,
            lat: 31.288167
          }
        },
        {
          citycode: "0713",
          adcode: "421125",
          name: "浠水县",
          center: {
            lng: 115.265155,
            lat: 30.452212
          }
        },
        {
          citycode: "0713",
          adcode: "421126",
          name: "蕲春县",
          center: {
            lng: 115.436423,
            lat: 30.226146
          }
        },
        {
          citycode: "0713",
          adcode: "421182",
          name: "武穴市",
          center: {
            lng: 115.595451,
            lat: 29.869602
          }
        }
      ]
    },
    {
      citycode: "1728",
      adcode: "429006",
      name: "天门市",
      center: {
        lng: 113.166545,
        lat: 30.663706
      },
      districtList: [
        {
          citycode: "1728",
          adcode: "429006",
          name: "胡市镇",
          center: {
            lng: 113.422187,
            lat: 30.802027
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "黄潭镇",
          center: {
            lng: 113.038506,
            lat: 30.69216
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "多祥镇",
          center: {
            lng: 113.357891,
            lat: 30.423413
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "沉湖管委会",
          center: {
            lng: 113.398615,
            lat: 30.458799
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "干驿镇",
          center: {
            lng: 113.450967,
            lat: 30.502984
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "马湾镇",
          center: {
            lng: 113.312283,
            lat: 30.599323
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "横林镇",
          center: {
            lng: 113.21459,
            lat: 30.564294
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "蒋湖农场",
          center: {
            lng: 112.779827,
            lat: 30.630562
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "小板镇",
          center: {
            lng: 113.263987,
            lat: 30.615139
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "岳口镇",
          center: {
            lng: 113.105,
            lat: 30.586764
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "蒋场镇",
          center: {
            lng: 112.927266,
            lat: 30.646031
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "石家河镇",
          center: {
            lng: 113.076431,
            lat: 30.821122
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "彭市镇",
          center: {
            lng: 113.157308,
            lat: 30.431522
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "九真镇",
          center: {
            lng: 113.206379,
            lat: 30.824523
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "佛子山镇",
          center: {
            lng: 113.067782,
            lat: 30.689228
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "竟陵街道",
          center: {
            lng: 113.182938,
            lat: 30.706618
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "侯口街道",
          center: {
            lng: 113.133899,
            lat: 30.652014
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "麻洋镇",
          center: {
            lng: 113.309397,
            lat: 30.5249
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "杨林街道",
          center: {
            lng: 113.265467,
            lat: 30.685636
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "汪场镇",
          center: {
            lng: 112.978692,
            lat: 30.638003
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "白茅湖农场",
          center: {
            lng: 113.063412,
            lat: 30.586804
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "皂市镇",
          center: {
            lng: 113.223245,
            lat: 30.795738
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "拖市镇",
          center: {
            lng: 112.841174,
            lat: 30.729303
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "卢市镇",
          center: {
            lng: 113.396655,
            lat: 30.659558
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "净潭乡",
          center: {
            lng: 113.450669,
            lat: 30.646405
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "多宝镇",
          center: {
            lng: 112.705302,
            lat: 30.627076
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "渔薪镇",
          center: {
            lng: 112.889649,
            lat: 30.668912
          }
        },
        {
          citycode: "1728",
          adcode: "429006",
          name: "张港镇",
          center: {
            lng: 112.911875,
            lat: 30.578584
          }
        }
      ]
    },
    {
      citycode: "0712",
      adcode: "420900",
      name: "孝感市",
      center: {
        lng: 113.956962,
        lat: 30.918311
      },
      districtList: [
        {
          citycode: "0712",
          adcode: "420923",
          name: "云梦县",
          center: {
            lng: 113.752958,
            lat: 31.021736
          }
        },
        {
          citycode: "0712",
          adcode: "420902",
          name: "孝南区",
          center: {
            lng: 113.910769,
            lat: 30.91695
          }
        },
        {
          citycode: "0712",
          adcode: "420984",
          name: "汉川市",
          center: {
            lng: 113.838068,
            lat: 30.673219
          }
        },
        {
          citycode: "0712",
          adcode: "420981",
          name: "应城市",
          center: {
            lng: 113.571864,
            lat: 30.928592
          }
        },
        {
          citycode: "0712",
          adcode: "420982",
          name: "安陆市",
          center: {
            lng: 113.688955,
            lat: 31.25565
          }
        },
        {
          citycode: "0712",
          adcode: "420921",
          name: "孝昌县",
          center: {
            lng: 113.997794,
            lat: 31.258225
          }
        },
        {
          citycode: "0712",
          adcode: "420922",
          name: "大悟县",
          center: {
            lng: 114.127122,
            lat: 31.561179
          }
        }
      ]
    },
    {
      citycode: "0724",
      adcode: "420800",
      name: "荆门市",
      center: {
        lng: 112.199009,
        lat: 31.035445
      },
      districtList: [
        {
          citycode: "0724",
          adcode: "420882",
          name: "京山市",
          center: {
            lng: 113.119561,
            lat: 31.018414
          }
        },
        {
          citycode: "0724",
          adcode: "420822",
          name: "沙洋县",
          center: {
            lng: 112.588675,
            lat: 30.709167
          }
        },
        {
          citycode: "0724",
          adcode: "420804",
          name: "掇刀区",
          center: {
            lng: 112.2079,
            lat: 30.973397
          }
        },
        {
          citycode: "0724",
          adcode: "420802",
          name: "东宝区",
          center: {
            lng: 112.201657,
            lat: 31.05187
          }
        },
        {
          citycode: "0724",
          adcode: "420881",
          name: "钟祥市",
          center: {
            lng: 112.588032,
            lat: 31.167933
          }
        }
      ]
    },
    {
      citycode: "2728",
      adcode: "429005",
      name: "潜江市",
      center: {
        lng: 112.900279,
        lat: 30.401954
      },
      districtList: [
        {
          citycode: "2728",
          adcode: "429005",
          name: "广华寺街道",
          center: {
            lng: 112.666286,
            lat: 30.463319
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "泰丰街道",
          center: {
            lng: 112.980898,
            lat: 30.416671
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "周矶管理区",
          center: {
            lng: 112.785657,
            lat: 30.463577
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "高场街道",
          center: {
            lng: 112.774574,
            lat: 30.407577
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "总口管理区",
          center: {
            lng: 112.890449,
            lat: 30.258095
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "王场镇",
          center: {
            lng: 112.818521,
            lat: 30.490597
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "运粮湖管理区",
          center: {
            lng: 112.58182,
            lat: 30.252044
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "园林街道",
          center: {
            lng: 112.910007,
            lat: 30.376965
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "白鹭湖管理区",
          center: {
            lng: 112.715593,
            lat: 30.178757
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "竹根滩镇",
          center: {
            lng: 112.979245,
            lat: 30.471601
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "渔洋镇",
          center: {
            lng: 112.966486,
            lat: 30.239237
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "熊口镇",
          center: {
            lng: 112.724425,
            lat: 30.340363
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "熊口管理区",
          center: {
            lng: 112.806208,
            lat: 30.256835
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "后湖管理区",
          center: {
            lng: 112.767709,
            lat: 30.404874
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "张金镇",
          center: {
            lng: 112.57725,
            lat: 30.238919
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "杨市街道",
          center: {
            lng: 112.914959,
            lat: 30.383464
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "高石碑镇",
          center: {
            lng: 112.62557,
            lat: 30.62034
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "周矶街道",
          center: {
            lng: 112.781398,
            lat: 30.391044
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "积玉口镇",
          center: {
            lng: 112.634123,
            lat: 30.398499
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "泽口街道",
          center: {
            lng: 112.915656,
            lat: 30.48816
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "浩口镇",
          center: {
            lng: 112.566899,
            lat: 30.307792
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "老新镇",
          center: {
            lng: 112.887009,
            lat: 30.215033
          }
        },
        {
          citycode: "2728",
          adcode: "429005",
          name: "龙湾镇",
          center: {
            lng: 112.780855,
            lat: 30.253634
          }
        }
      ]
    },
    {
      citycode: "0718",
      adcode: "422800",
      name: "恩施土家族苗族自治州",
      center: {
        lng: 109.488076,
        lat: 30.272104
      },
      districtList: [
        {
          citycode: "0718",
          adcode: "422822",
          name: "建始县",
          center: {
            lng: 109.722333,
            lat: 30.602195
          }
        },
        {
          citycode: "0718",
          adcode: "422801",
          name: "恩施市",
          center: {
            lng: 109.479572,
            lat: 30.295148
          }
        },
        {
          citycode: "0718",
          adcode: "422802",
          name: "利川市",
          center: {
            lng: 108.936456,
            lat: 30.290974
          }
        },
        {
          citycode: "0718",
          adcode: "422825",
          name: "宣恩县",
          center: {
            lng: 109.489918,
            lat: 29.986856
          }
        },
        {
          citycode: "0718",
          adcode: "422826",
          name: "咸丰县",
          center: {
            lng: 109.140163,
            lat: 29.665215
          }
        },
        {
          citycode: "0718",
          adcode: "422827",
          name: "来凤县",
          center: {
            lng: 109.407697,
            lat: 29.493474
          }
        },
        {
          citycode: "0718",
          adcode: "422828",
          name: "鹤峰县",
          center: {
            lng: 110.034011,
            lat: 29.890073
          }
        },
        {
          citycode: "0718",
          adcode: "422823",
          name: "巴东县",
          center: {
            lng: 110.340921,
            lat: 31.042854
          }
        }
      ]
    },
    {
      citycode: "0728",
      adcode: "429004",
      name: "仙桃市",
      center: {
        lng: 113.442973,
        lat: 30.328407
      },
      districtList: [
        {
          citycode: "0728",
          adcode: "429004",
          name: "通海口镇",
          center: {
            lng: 113.20573,
            lat: 30.272193
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "胡场镇",
          center: {
            lng: 113.290392,
            lat: 30.4278
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "干河街道",
          center: {
            lng: 113.451023,
            lat: 30.375391
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "杨林尾镇",
          center: {
            lng: 113.561091,
            lat: 30.20143
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "彭场镇",
          center: {
            lng: 113.445865,
            lat: 30.251787
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "沔城回族镇",
          center: {
            lng: 113.200597,
            lat: 30.192111
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "龙华山街道",
          center: {
            lng: 113.460323,
            lat: 30.364932
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "沙湖原种场",
          center: {
            lng: 113.642513,
            lat: 30.148174
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "郑场镇",
          center: {
            lng: 112.978652,
            lat: 30.470679
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "郭河镇",
          center: {
            lng: 113.303624,
            lat: 30.302698
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "排湖风景区",
          center: {
            lng: 113.223499,
            lat: 30.298659
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "沙嘴街道",
          center: {
            lng: 113.441389,
            lat: 30.359636
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "毛嘴镇",
          center: {
            lng: 113.045359,
            lat: 30.418813
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "张沟镇",
          center: {
            lng: 113.438252,
            lat: 30.296766
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "三伏潭镇",
          center: {
            lng: 113.206929,
            lat: 30.339491
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "五湖渔场",
          center: {
            lng: 113.768784,
            lat: 30.187345
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "西流河镇",
          center: {
            lng: 113.762133,
            lat: 30.296361
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "长埫口镇",
          center: {
            lng: 113.744972,
            lat: 30.356683
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "杜湖街道",
          center: {
            lng: 113.364736,
            lat: 30.306324
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "剅河镇",
          center: {
            lng: 112.98767,
            lat: 30.375691
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "沙湖镇",
          center: {
            lng: 113.71982,
            lat: 30.118003
          }
        },
        {
          citycode: "0728",
          adcode: "429004",
          name: "陈场镇",
          center: {
            lng: 113.0599,
            lat: 30.294262
          }
        }
      ]
    },
    {
      citycode: "0715",
      adcode: "421200",
      name: "咸宁市",
      center: {
        lng: 114.322601,
        lat: 29.84135
      },
      districtList: [
        {
          citycode: "0715",
          adcode: "421221",
          name: "嘉鱼县",
          center: {
            lng: 113.939249,
            lat: 29.970575
          }
        },
        {
          citycode: "0715",
          adcode: "421202",
          name: "咸安区",
          center: {
            lng: 114.299002,
            lat: 29.852726
          }
        },
        {
          citycode: "0715",
          adcode: "421224",
          name: "通山县",
          center: {
            lng: 114.482832,
            lat: 29.606468
          }
        },
        {
          citycode: "0715",
          adcode: "421281",
          name: "赤壁市",
          center: {
            lng: 113.900385,
            lat: 29.725122
          }
        },
        {
          citycode: "0715",
          adcode: "421223",
          name: "崇阳县",
          center: {
            lng: 114.039484,
            lat: 29.556866
          }
        },
        {
          citycode: "0715",
          adcode: "421222",
          name: "通城县",
          center: {
            lng: 113.816811,
            lat: 29.2454
          }
        }
      ]
    },
    {
      citycode: "0716",
      adcode: "421000",
      name: "荆州市",
      center: {
        lng: 112.24143,
        lat: 30.336282
      },
      districtList: [
        {
          citycode: "0716",
          adcode: "421024",
          name: "江陵县",
          center: {
            lng: 112.424581,
            lat: 30.042227
          }
        },
        {
          citycode: "0716",
          adcode: "421088",
          name: "监利市",
          center: {
            lng: 112.904634,
            lat: 29.840229
          }
        },
        {
          citycode: "0716",
          adcode: "421087",
          name: "松滋市",
          center: {
            lng: 111.756455,
            lat: 30.174717
          }
        },
        {
          citycode: "0716",
          adcode: "421083",
          name: "洪湖市",
          center: {
            lng: 113.475984,
            lat: 29.827256
          }
        },
        {
          citycode: "0716",
          adcode: "421022",
          name: "公安县",
          center: {
            lng: 112.229742,
            lat: 30.058519
          }
        },
        {
          citycode: "0716",
          adcode: "421081",
          name: "石首市",
          center: {
            lng: 112.42538,
            lat: 29.720944
          }
        },
        {
          citycode: "0716",
          adcode: "421003",
          name: "荆州区",
          center: {
            lng: 112.190282,
            lat: 30.352984
          }
        },
        {
          citycode: "0716",
          adcode: "421002",
          name: "沙市区",
          center: {
            lng: 112.251975,
            lat: 30.326693
          }
        }
      ]
    },
    {
      citycode: "1719",
      adcode: "429021",
      name: "神农架林区",
      center: {
        lng: 110.675879,
        lat: 31.745103
      },
      districtList: [
        {
          citycode: "1719",
          adcode: "429021",
          name: "木鱼镇",
          center: {
            lng: 110.566502,
            lat: 31.366101
          }
        },
        {
          citycode: "1719",
          adcode: "429021",
          name: "新华镇",
          center: {
            lng: 110.842423,
            lat: 31.621763
          }
        },
        {
          citycode: "1719",
          adcode: "429021",
          name: "红坪镇",
          center: {
            lng: 110.196111,
            lat: 31.471819
          }
        },
        {
          citycode: "1719",
          adcode: "429021",
          name: "宋洛乡",
          center: {
            lng: 110.589789,
            lat: 31.73029
          }
        },
        {
          citycode: "1719",
          adcode: "429021",
          name: "松柏镇",
          center: {
            lng: 110.609207,
            lat: 31.704132
          }
        },
        {
          citycode: "1719",
          adcode: "429021",
          name: "阳日镇",
          center: {
            lng: 110.763336,
            lat: 31.676979
          }
        },
        {
          citycode: "1719",
          adcode: "429021",
          name: "下谷坪土家族乡",
          center: {
            lng: 110.124191,
            lat: 31.394918
          }
        },
        {
          citycode: "1719",
          adcode: "429021",
          name: "大九湖镇",
          center: {
            lng: 110.106251,
            lat: 31.408207
          }
        }
      ]
    },
    {
      citycode: "0722",
      adcode: "421300",
      name: "随州市",
      center: {
        lng: 113.382324,
        lat: 31.690275
      },
      districtList: [
        {
          citycode: "0722",
          adcode: "421321",
          name: "随县",
          center: {
            lng: 113.29097,
            lat: 31.883233
          }
        },
        {
          citycode: "0722",
          adcode: "421303",
          name: "曾都区",
          center: {
            lng: 113.371052,
            lat: 31.716423
          }
        },
        {
          citycode: "0722",
          adcode: "421381",
          name: "广水市",
          center: {
            lng: 113.825977,
            lat: 31.617015
          }
        }
      ]
    },
    {
      citycode: "0711",
      adcode: "420700",
      name: "鄂州市",
      center: {
        lng: 114.894909,
        lat: 30.391461
      },
      districtList: [
        {
          citycode: "0711",
          adcode: "420703",
          name: "华容区",
          center: {
            lng: 114.729945,
            lat: 30.53515
          }
        },
        {
          citycode: "0711",
          adcode: "420702",
          name: "梁子湖区",
          center: {
            lng: 114.684805,
            lat: 30.100146
          }
        },
        {
          citycode: "0711",
          adcode: "420704",
          name: "鄂城区",
          center: {
            lng: 114.89157,
            lat: 30.400535
          }
        }
      ]
    },
    {
      citycode: "0714",
      adcode: "420200",
      name: "黄石市",
      center: {
        lng: 115.038999,
        lat: 30.201082
      },
      districtList: [
        {
          citycode: "0714",
          adcode: "420205",
          name: "铁山区",
          center: {
            lng: 114.891603,
            lat: 30.203152
          }
        },
        {
          citycode: "0714",
          adcode: "420204",
          name: "下陆区",
          center: {
            lng: 114.960914,
            lat: 30.174148
          }
        },
        {
          citycode: "0714",
          adcode: "420203",
          name: "西塞山区",
          center: {
            lng: 115.110067,
            lat: 30.205114
          }
        },
        {
          citycode: "0714",
          adcode: "420281",
          name: "大冶市",
          center: {
            lng: 114.98046,
            lat: 30.096263
          }
        },
        {
          citycode: "0714",
          adcode: "420222",
          name: "阳新县",
          center: {
            lng: 115.215211,
            lat: 29.830236
          }
        },
        {
          citycode: "0714",
          adcode: "420202",
          name: "黄石港区",
          center: {
            lng: 115.065653,
            lat: 30.223194
          }
        }
      ]
    }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/hubei.js